import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { setUserInfo } from '../../common/users/actions'
import { SetLanguagesForm } from '../forms'

const SetLanguagesPage = ({ setUserInfo }) => (
  <div className="set-languages overlay-container">
    <SetLanguagesForm
      submit={setUserInfo}
    />
  </div>
)

SetLanguagesPage.propTypes = {
  setUserInfo: PropTypes.func.isRequired,
}

const enhance = compose(
  connect(() => ({ }), { setUserInfo }),
)

export default enhance(SetLanguagesPage)



// WEBPACK FOOTER //
// ./src/browser/pages/SetLanguagesPage.js